import React from 'react';
import { Checkbox as MuiCheckbox } from '@material-ui/core';
import type { CheckboxProps, Theme } from '@material-ui/core';

import { IconName, Illustration } from '@klp/design/Illustrations';
import type { IKlpPalette, KlpStyled } from '@klp/design/Theme';
import { removeKlpStyles } from '@klp/design/Theme';
import { useKlpStyles } from '../Theme/useKlpStyles';

const styles = (theme: Theme) => ({
    primary: {
        '& .MuiIconButton-label': {
            border: '2px solid transparent',
            borderColor: theme.palette.primary.main,
            '& > *': {
                display: 'flex',
            },
        },
    },
    secondary: {
        '& .MuiIconButton-label': {
            border: '2px solid transparent',
            borderColor: theme.palette.secondary.main,
            '& > *': {
                display: 'flex',
            },
        },
    },
    iconHidden: {
        visibility: 'hidden',
    },
});

export type ICheckboxProps = KlpStyled &
    CheckboxProps & {
        klpPalette?: Extract<IKlpPalette, 'primary' | 'secondary'>;
    };

export const Checkbox: React.FC<ICheckboxProps> = (props) => {
    const { klpColor = 'dark', klpPalette = 'secondary', ...restProps } = props;
    const classes = useKlpStyles(props, styles);

    return (
        <MuiCheckbox
            {...removeKlpStyles(restProps)}
            className={classes[klpPalette]}
            size="small"
            checkedIcon={
                <Illustration
                    icon={IconName.CHECK}
                    klpColor={klpColor}
                    klpPalette={klpPalette}
                    size="mini"
                />
            }
            icon={
                <Illustration
                    className={classes.iconHidden}
                    icon={IconName.CHECK}
                    klpColor={klpColor}
                    klpPalette={klpPalette}
                    size="mini"
                />
            }
            disableRipple={true}
        />
    );
};
